import { useEffect, useRef, useState } from "react";
import "./index.scss";
import Loader from "react-loaders";
import AnimatedLetters from "../AnimatedLetters";
import emailjs from "@emailjs/browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

const Contact = () => {
  const [letterClass, setLetterClass] = useState("text-animate");
  const form = useRef();

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_owmh00a",
        "template_wy932pg",
        form.current,
        "XAv2_kx9h3hBthuC2"
      )
      .then(
        (res) => {
          alert("Message successfully sent!");
          window.location.reload(false);
        },
        (e) => {
          console.log(e);
          alert("Failed to send the message, please try again");
        }
      );
  };
  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              arr={["C", "o", "n", "t", "a", "c", "t", " ", "M", "e"]}
              index={15}
            />
          </h1>
          <div className="contact-form">
            <form ref={form} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input type="text" name="name" placeholder="Name" required />
                </li>
                <li className="half">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    required
                  />
                </li>
                <li>
                  <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="flat-button" value="SEND" />
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="about-zone">
          <ul>
            <li>
              <FontAwesomeIcon
                className="icon"
                icon={faPhone}
                colorr="#d7cec7"
              />
              +1 201 466 1513
            </li>
            <li>
              <FontAwesomeIcon
                className="icon"
                icon={faLocationDot}
                colorr="#d7cec7"
              />
              New York City
            </li>
            <li>
              <FontAwesomeIcon
                className="icon"
                icon={faEnvelope}
                colorr="#d7cec7"
              />
              ohbrian12@gmail.com
            </li>
          </ul>
        </div>
      </div>
      <Loader type="ball-pulse" />
    </>
  );
};

export default Contact;
